import * as Yup from 'yup'

export const projectsValidationRules = Yup.object().shape({
  name: Yup.string().required('name is required'),
  start_date: Yup.string().required('start date is required'),
  end_date: Yup.string().required('end date is required')
});